import React, { useContext } from "react";

import { Icon } from "@culturehq/components";

import { Trans } from "app/utils";

import checkRequiredDetails from "components/editor/checkRequiredDetails";
import { StoryModalContext } from "components/stories/video-studio/contexts/StoryContext";
import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";

const DetailsTitle: React.FC<{}> = () => {
  const { selectedBody } = useContext(StoryModalContext);
  const { data: { storyQuestionId } } = useContext(CreatomateContext);

  return (
    <h2 className="Stories-Container__Title">
      {!checkRequiredDetails({ storyQuestionId, selectedBody })
        ? <Icon className="Required-Icon" icon="info" />
        : <Icon className="Completed-Icon" icon="ios-checkmark" />}
      <Trans>Story details</Trans>
    </h2>
  );
};

export default DetailsTitle;
